import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const AirtableIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#clip0_24353_71389)">
      <path
        d="M8.93653 1.68768L1.47523 4.77503C1.06031 4.94674 1.06461 5.5362 1.48213 5.70169L8.97454 8.67286C9.63283 8.93395 10.3659 8.93395 11.0242 8.67286L18.5168 5.70158C18.9342 5.5362 18.9387 4.94685 18.5235 4.77514L11.0625 1.68757C10.3818 1.4059 9.61712 1.4059 8.93642 1.68757"
        fill="#FCB400"
      />
      <path
        d="M10.6641 10.2953V17.7178C10.6641 18.0707 11.02 18.3126 11.3482 18.1825L19.697 14.9419C19.7901 14.905 19.87 14.8409 19.9263 14.7581C19.9826 14.6752 20.0126 14.5774 20.0126 14.4772V7.05481C20.0126 6.70177 19.6566 6.46003 19.3285 6.59012L10.9797 9.83074C10.8866 9.86767 10.8067 9.93172 10.7504 10.0146C10.6942 10.0974 10.6641 10.1953 10.6641 10.2954"
        fill="#18BFFF"
      />
      <path
        d="M8.71442 10.6782L6.23668 11.8745L5.9851 11.9961L0.754727 14.5023C0.423289 14.6622 0 14.4206 0 14.0523V7.08577C0 6.95251 0.0683236 6.83747 0.15995 6.75093C0.197539 6.7135 0.240184 6.68152 0.286642 6.65592C0.411525 6.58092 0.5898 6.5609 0.741379 6.62085L8.6728 9.76351C9.07595 9.92346 9.10762 10.4884 8.71442 10.6783"
        fill="#F82B60"
      />
      <path
        d="M8.71463 10.6782L6.23688 11.8745L0.160156 6.75082C0.197753 6.71343 0.240397 6.68149 0.286849 6.65592C0.411732 6.58092 0.590007 6.5609 0.741585 6.62085L8.673 9.76351C9.07616 9.92346 9.10783 10.4884 8.71463 10.6783"
        fill="black"
        fillOpacity="0.25"
      />
    </g>
    <defs>
      <clipPath id="clip0_24353_71389">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
